<template>
  <v-footer app
            color="white"
            absolute
            inset
            max-height="30px"
            tile>
    <div class="text-caption d-flex">
      <div class="mr-3">
        &copy; {{ new Date().getFullYear() }} Mobile Locker. All Rights Reserved.
      </div>
      <div class="mr-3">
        <a href="https://app.mobilelocker.com/shared/terms-of-service?utm_source=site_footer" target="_blank">Terms of Service</a>
      </div>
      <div class="mr-3">
        <a href="https://app.mobilelocker.com/shared/privacy-policy?utm_source=site_footer" target="_blank">Privacy Policy</a>
      </div>
    </div>
    <v-spacer></v-spacer>
    <div class="text-caption">
      <a href="https://www.mobilelocker.com/downloads/?utm_source=site_footer" target="_blank">Install the apps</a>
    </div>
    <!--<v-spacer></v-spacer>
    <div class="overline">
      Built with <v-icon class="pink&#45;&#45;text">fas fa-heart</v-icon>
    </div>-->
  </v-footer>
</template>

<script>

export default {
  name: 'page-footer',
}
</script>
